module.exports = __webpack_public_path__ + "img/ygg.c9859897.png";